import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ProductDetailsComponent } from "./products/product-details/product-details.component";
import { ProductLeftSidebarComponent } from "./products/product-left-sidebar/product-left-sidebar.component";
import { HomeFiveComponent } from "./home-five/home-five.component";
import { ProductsInfoComponent } from "./products/products-info/products-info.component";
import { HomeSixComponent } from "./home-six/home-six.component";
import { ProformasEccComponent } from "./products/proformasEcc/proformas-ecc/proformas-ecc.component";
import { VistaPreviaListComponent } from "./vistaPrevia/vista-previa-list/vista-previa-list.component";
import { VistaPreviaDetailComponent } from "./vistaPrevia/vista-previa-detail/vista-previa-detail.component";
import { ProductV2Component } from "./products/product-v2/product-v2.component";

// Routes
const routes: Routes = [
  { path: "five", component: HomeFiveComponent },
  { path: "six", component: HomeSixComponent },
  { path: "proformaEcc", component: ProformasEccComponent },
  {
    path: "products/:category/:criterio/:gamer/:marca/:procesador/:almacenamiento/:page",
    component: ProductLeftSidebarComponent,
  },
  { path: "product/:id", component: ProductDetailsComponent },
  {
    path: "productsInfo/:category/:gamer/:marca/:procesador/:almacenamiento/:page",
    component: ProductsInfoComponent,
  },
  {
    path: "vistaPrevia",
    component: VistaPreviaListComponent,
  },
  {
    path: "vistaPreviaDet",
    component: VistaPreviaDetailComponent,
  },
  {
    path: "producto",
    component: ProductV2Component,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShopRoutingModule {}
